import { render, staticRenderFns } from "./supervisionList.vue?vue&type=template&id=599bfc01&scoped=true"
import script from "./supervisionList.vue?vue&type=script&lang=js"
export * from "./supervisionList.vue?vue&type=script&lang=js"
import style0 from "./supervisionList.vue?vue&type=style&index=0&id=599bfc01&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599bfc01",
  null
  
)

export default component.exports